import { Box, Text, Heading } from "rebass";
import { maxWidth } from "styled-system";
import styled from "styled-components";

const Banner = ({ title, description }) => {
  return (
    <Box px={[3, 3, 3, 4]} pb={[4, 5, 6]} pt={[3, 3, 3, 7]}>
      <Inner maxWidth={[500, 500, 0]} mx={"auto"} textAlign="center">
        {title && (
          <Title
            as="h1"
            fontFamily="medium"
            letterSpacing={2}
            fontSize={[5, 5, 7]}
          >
            {title}
          </Title>
        )}
        {description && (
          <Text mt={[2, 2, 3]} fontSize={[2, 2, 4]} lineHeight={1.25}>
            {description}
          </Text>
        )}
      </Inner>
    </Box>
  );
};

const Inner = styled(Text)`
  ${maxWidth}
`;

const Title = styled(Heading)`
  text-transform: uppercase;
`;

export { Banner };
